module.exports = __webpack_public_path__ + "img/TIVA.5558ddc2.png";